/**
 * Returns true when the current pathname is a patient-facing public route,
 * OR when the host is the patient-hub domain (which only ever serves public
 * patient views — see `patientHubRoutes` in src/routes/index.jsx).
 *
 * Used to hide CRM-internal UI (settings widget, help button, version-update
 * snackbar, offline snackbar, error overlays) that should never leak into
 * patient views.
 */
const PUBLIC_PREFIXES = [
    '/consent',
    '/forms',
    '/survey',
    '/booking',
    '/appointments/feedback',
    '/lead-treatments/aligner-approve',
    '/privacy-policy',
];

const isPatientHubHost = () => {
    if (typeof window === 'undefined') return false;
    const { hostname } = window.location;
    return hostname === 'patient-hub.co.uk' || hostname.endsWith('.patient-hub.co.uk');
};

export default function isPublicRoute(pathname) {
    if (isPatientHubHost()) return true;
    if (pathname === '/book' || pathname.startsWith('/book/')) return true;
    return PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
